import { pointApi } from "Apis/apis";
import Button from "Components/Atoms/Button/button";
import Flex from "Components/Atoms/Flex/flex";
import Space from "Components/Atoms/Space/space";
import Caption from "Components/Atoms/Text/caption";
import HeadLine from "Components/Atoms/Text/headLine";
import Title from "Components/Atoms/Text/title";
import Detailmodal from "Components/Molecules/Modal/detailmodal";
import { modalToggle } from "Store/Slices/modal";
import { useAppDispatch } from "Store/store";
import { comma, dateFormat, getIdx } from "Util/function";
import { Table } from "antd";
import { ReactComponent as Search } from "Util/Svgs/search.svg";
import type { TableProps } from "antd";
import { useEffect, useState } from "react";
import { PointT } from "types/interface";
import ModifyModal from "./ModifyModal/modifyModal";
import { useLocation } from "react-router-dom";
import SearchModal from "Components/Molecules/Modal/searchModal";

interface ListModalProps {
  row: PointT;
}
const DATA = [
  { key: "index", val: "index", type: "text" },
  { key: "identifier", val: "ID", type: "text" },
  { key: "nickname", val: "닉네임", type: "text" },
  { key: "createdAt", val: "가입일", type: "date" },
];

const PointModal = ({ row }: ListModalProps) => {
  return (
    <Detailmodal title={`포인트 #${row.index}`} modalNum={1}>
      <Flex py={12}>
        <div className="w-180">
          <Caption text="ID" />
        </div>
        <div className="flex-1">
          <Caption color="text-headline" text={row.identifier} />
        </div>
      </Flex>
      <Flex py={12}>
        <div className="w-180">
          <Caption text="닉네임" />
        </div>
        <div className="flex-1">
          <Caption color="text-headline" text={row.nickname} />
        </div>
      </Flex>
      <Flex py={12}>
        <div className="w-180">
          <Caption text="세부내용" />
        </div>
        <div className="flex-1">
          <Caption color="text-headline" text={row.usage} />
        </div>
      </Flex>
      <Flex py={12}>
        <div className="w-180">
          <Caption text="포인트" />
        </div>
        <div className="flex-1">
          <Caption color="text-headline" text={row.pointAmount} />
        </div>
      </Flex>
      <Flex py={12}>
        <div className="w-180">
          <Caption text="구매상품" />
        </div>
        <div className="flex-1">
          <Caption color="text-headline" text={row.product} />
        </div>
      </Flex>
      <Flex py={12}>
        <div className="w-180">
          <Caption text="일자" />
        </div>
        <div className="flex-1">
          <Caption color="text-headline" text={dateFormat(row.createdAt)} />
        </div>
      </Flex>
    </Detailmodal>
  );
};
const Point = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [pointList, setPointList] = useState<PointT[]>([]);
  const [max, setMax] = useState(0);
  const [selectedRowIdx, setSelectedRowIdx] = useState(-1);

  const getPointList = async () => {
    const { key = "", val = "" } = location.state || {};
    const {
      data: { data },
    } = await pointApi.get(`${key}=${val}`);

    setMax(data.pointsCount);
    setPointList(data.points);
  };

  const columns: TableProps<PointT>["columns"] = [
    {
      title: "idx",
      dataIndex: "index",
      key: "index",
      width: 80,
      sortDirections: ["ascend"],
      sorter: (a, b) => a.index - b.index,
      render: (a) => getIdx(pointList, a, "index"),
    },
    {
      title: "ID",
      dataIndex: "identifier",
      key: "identifier",
      sorter: (a, b) => a.identifier.localeCompare(b.identifier),
    },
    {
      title: "닉네임",
      dataIndex: "nickname",
      key: "nickname",
      sorter: (a, b) => a.nickname.localeCompare(b.nickname),
    },
    {
      title: "세부내용",
      dataIndex: "usage",
      key: "usage",
      sorter: (a, b) => a.usage.localeCompare(b.usage),
    },
    {
      title: "포인트",
      dataIndex: "pointAmount",
      key: "pointAmount",
      sorter: (a, b) => a.pointAmount - b.pointAmount,
      render: (point) => {
        const isPositive = point > 0;
        return (
          <span className={`${isPositive ? "text-primary" : "text-red-500"}`}>
            {isPositive && "+"}
            {comma(point)}
          </span>
        );
      },
    },
    {
      title: "구매상품",
      dataIndex: "product",
      key: "product",
      sorter: (a, b) => a.product.localeCompare(b.product),
    },
    {
      title: "일자",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 135,
      sorter: (a, b) => a.createdAt.localeCompare(b.createdAt),

      render: (date) => dateFormat(date),
    },
  ];

  useEffect(() => {
    getPointList();
  }, [location]);

  return (
    <div>
      <Flex x="justify-between">
        <HeadLine text="포인트 관리" extraBold />
        <button onClick={() => dispatch(modalToggle(100))}>
          <Search />
        </button>
      </Flex>
      <Space y={37} />
      <div className="p-32 bg-white rounded-xl">
        <Flex>
          <Title text={`${max}개의 항목`} />
          <Space x={23} />
          <Button
            color="bg-progress"
            onClick={() => {
              dispatch(modalToggle(2));
            }}
            text="포인트 지급 / 차감"
            full={false}
          />
        </Flex>
        <Space y={23} />
        <Table
          rowKey="index"
          size="middle"
          pagination={{ position: ["bottomCenter"] }}
          columns={columns}
          dataSource={pointList}
          onRow={(record) => {
            return {
              onClick: (e) => {
                setSelectedRowIdx(record.index);
                dispatch(modalToggle(1));
              },
            };
          }}
        />
      </div>
      {selectedRowIdx !== -1 && (
        <PointModal
          row={
            pointList.find((el) => el.index === selectedRowIdx) ||
            ({} as PointT)
          }
        />
      )}
      <ModifyModal getPointList={getPointList} />
      <SearchModal data={DATA} />
    </div>
  );
};

export default Point;
